import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatApiErrorDetail } from "@/lib/api";
import { Radar, Loader2 } from "lucide-react";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/dashboard");
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex bg-grid">
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <Link to="/" className="flex items-center gap-2.5 mb-8" data-testid="login-brand">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-700 flex items-center justify-center">
              <Radar className="w-5 h-5 text-emerald-950" />
            </div>
            <div className="font-display text-xl font-extrabold">LeilãoRadar AI</div>
          </Link>
          <h1 className="font-display text-3xl font-bold text-white">Bem-vindo de volta</h1>
          <p className="mt-2 text-sm text-slate-400">Entre para continuar caçando oportunidades.</p>

          <form onSubmit={onSubmit} className="mt-8 space-y-4" data-testid="login-form">
            <div>
              <Label htmlFor="email" className="text-slate-300">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 bg-slate-900 border-slate-800 h-11" data-testid="login-email-input" />
            </div>
            <div>
              <Label htmlFor="password" className="text-slate-300">Senha</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-1.5 bg-slate-900 border-slate-800 h-11" data-testid="login-password-input" />
            </div>
            {error && <div className="text-sm text-red-400" data-testid="login-error">{error}</div>}
            <Button type="submit" disabled={loading} className="w-full h-11 bg-emerald-500 hover:bg-emerald-600 text-emerald-950 font-semibold" data-testid="login-submit-btn">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Entrar"}
            </Button>
          </form>
          <p className="mt-6 text-sm text-slate-400 text-center">
            Não tem conta? <Link to="/register" className="text-emerald-400 hover:text-emerald-300" data-testid="login-to-register">Criar agora</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
